import React from "react"
import styled from "styled-components"
import { CarouselProvider, ButtonBack, ButtonNext } from "pure-react-carousel"

import { minWidth } from "utils"

import Icon from "icons"
import CroppedImage from "components/cropped-image"

export { Slider, Slide } from "pure-react-carousel"

export const Wrapper = styled.div`
  position: relative;
  display: block;
  margin: 3rem 0 3.6rem 0;

  ${minWidth.tablet`
    margin: 3rem 0 3.6rem 0;
  `}

  ${minWidth.desktop`
    margin: 0 0 3.6rem 0;
  `}
`

export const Carousel = styled(CarouselProvider)`
  cursor: grab;

  :active {
    cursor: grabbing;
  }

  li.carousel__slide {
    height: 100%;
    padding-bottom: 0 !important;
  }

  div.carousel__inner-slide {
    position: static;
  }
`

export const ImageSlide = styled.div`
  position: relative;
`

export const DesktopImage = styled(CroppedImage)`
  width: 100%;
  padding-top: 77.8%;

  :first-child {
    margin-left: 0;
  }

  :last-child {
    margin-right: 0;
  }
`

export const StyledButtonBack = styled(ButtonBack)`
  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`

export const StyledButtonNext = styled(ButtonNext)`
  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`

export const MobileWrapper = styled.div`
  position: relative;

  ${minWidth.mobile`
    display: none;
  `}
`

const ScrollLabel = styled.div`
  font-size: 1.6rem;
  line-height: 2.2rem;
`

export const Scroll = ({ nImages }) =>
  nImages > 1 && (
    <>
      <ScrollLabel>scroll</ScrollLabel>
      <Icon viewBox="0 0 348 12" id="arrow-line-mobile" />
    </>
  )

export const ScrollableGrid = styled.div`
  display: -webkit-box;
  overflow-x: auto;
`

export const ImageCreditSource = styled.div`
  margin-top: 2rem;
  font-size: 1.1rem;
  line-height: 1.872rem;
  color: #222222;
  max-width: 80%;
  white-space: nowrap;
`

export const Arrows = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  width: fit-content;
  background: #fff;
  position: absolute;
  right: 0;
  bottom: -0.2rem;
`
